module.exports = __webpack_public_path__ + "media/images/wealthbar/transfers/transfer-withdrawal-2x-4c2b1b450632412d0d0dd261c63bfb02.png";